import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { FaCashRegister, FaEdit, FaEye, FaFilePdf, FaFolderOpen, FaPlus, FaPrint, FaTimes, FaTrash } from 'react-icons/fa';
import Modal from '../../../components/Modal';
import { formatDate, formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import DataTable from "react-data-table-component";
import Receipt from '../../../components/reciept';
import PaymentVoucher from '../../../components/PaymentVoucher';
import ReactToPrint from 'react-to-print';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { toast } from 'react-toastify';
import { customStyles } from '../../../styles';
import Select from 'react-select';

const CashbookPage = () => {
  const [cashbooks, setCashbooks] = useState([]);
  const [filteredCashbooks, setFilteredCashbooks] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedCashbook, setSelectedCashbook] = useState(null);
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    bank: '',
    customer: '',
    search: '',
  });

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({ id: "", date: "", description: "", cheque: "", project:'', sof:''});

  const [isOpen, setIsOpen] = useState(false);
  const [selectedObj, setSelectedObj] = useState(null);
  const [comment, setComment] = useState("");
  const [monthLockMap, setMonthLockMap] = useState({});

  const getMonthLockKey = (date, bankId) => {
    if (!date || !bankId) return "";
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    return `${bankId}-${month}-${year}`;
  };

  const checkMonthLockForRow = async (row) => {
    if (!row?.date || !row?.bank) return false;

    const key = getMonthLockKey(row.date, row.bank);
    if (!key) return false;

    if (monthLockMap[key] !== undefined) {
      return monthLockMap[key];
    }

    try {
      const dateObj = new Date(row.date);
      const month = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear();

      const response = await axios.post(rootUrl(`/checkMonthLock`), {
        month,
        bank: row.bank,
        year,
      });

      const isLocked = response.data?.locked || false;
      setMonthLockMap((prev) => ({ ...prev, [key]: isLocked }));
      return isLocked;
    } catch (error) {
      console.error("Error checking month lock:", error);
      return false;
    }
  };

  const isRowMonthLocked = (row) => {
    const key = getMonthLockKey(row?.date, row?.bank);
    return key ? monthLockMap[key] === true : false;
  };

  const openModal = async (obj) => {
    const isLocked = await checkMonthLockForRow(obj);
    if (isLocked) {
      toast.error("This month has been locked. Delete is not allowed.");
      return;
    }
    setSelectedObj(obj);
    setIsOpen(true);
  };

  const getOptionDetails = (option) => {
    const coaDetails = allData.coa?.find((a) => a.account == option.coa) || {};
    return {
        value: option.id,
        label: `${option.coa} - 
        ${coaDetails.name || ''} -
        ${allData.program.find(a=>a.programCode == option.program)?.name  || ''} -
        ${allData.subProgram.find(a=>parseFloat(a.subProgramCode) == parseFloat(option.subprogram)
        && a.programCode == option.program
        )?.name  || ''} -
        ${option.toy || ''} - 
        ${allData.dept.find(a=>a.id == option.dept)?.name  || ''}
        `
    };
};

  const {allData, setAllData} = useOutletContext();
  const handleEdit = async (row) => {
    const isLocked = await checkMonthLockForRow(row);
    if (isLocked) {
      toast.error("This month has been locked. Edit is not allowed.");
      return;
    }
    const prj = allData.projects.filter(a=>a.id == row.proj_id)?.map((res)=>({value:res.id, label:res.name}))[0]
    const Ebank = allData.bank.filter(a=>a.id == row.bank)?.map((res)=>({value:res.id, label:res.name}))[0]
    const ebudg = allData.budget.filter(a=>a.id == row.coa_id)?.map(getOptionDetails)[0]
    const Esof = allData.sof?.filter(a=>a.id == row.sof)?.map((res)=>({value:res.id, label:res.name}))[0]
    // const Epayee = allData.suppliers.filter(a=>a.id == row.paye)?.map((res)=>({value:res.id, label:res.name}))
    setEditData({ id: row.id, date: new Date(row.date).toISOString().split('T')[0], 
      description: row.description, cheque: row.cheque || "", project: prj , bank:Ebank, coa_id:ebudg, sof:Esof});
    setIsEditModalOpen(true);
  };

  

  // Handle input change
  const handleChange = (e) => {    
      setEditData({ ...editData, [e.target.name]: e.target.value });
      
  };

  const handleSelectChange = (data, name) => {

      if(data == null){
        setEditData({ ...editData, [name]:'' });
        return
      }
      setEditData({ ...editData, [name]:data});
  
  }



  // Submit updated values
  const handleSubmit =  () => {

    editData['uid'] = auth.user.id
       axios.post(rootUrl(`/editCash`), editData)
      toast.success("Successful")
      updateRow(editData);
      setIsEditModalOpen(false);
  };


  const updateRow = (updatedRow) => {
    setFilteredCashbooks((prev) =>
      prev.map((row) => {
        if (row.id !== updatedRow.id) return row;

        const updatedSof = updatedRow.sof ? updatedRow.sof.value : row.sof;

        return { 
          ...row, 
          description: updatedRow.description, 
          cheque: updatedRow.cheque, 
          date: updatedRow.date, 
          proj_id:updatedRow.project?.value, 
          bank:updatedRow.bank.value,
          sof: updatedSof
        };
      })
    );
  };  

  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [output, setOutput] = useState('');
  const [title, setTitle] = useState('');

  const auth = useAuth();

  const componentRef = useRef(null);

 const right = parseInt(auth.user.userType) === 2

function handleExportToPDF() {
  const input = componentRef.current;
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${title}.pdf`);
  });
}

const handlePrint = () => {
  const printContent = componentRef.current;
  const printWindow = window.open("", "", "width=800,height=600");

  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @media print {
            body { margin: 20px; }
          }
        </style>
      </head>
      <body class="p-4">${printContent.innerHTML}</body>
    </html>
  `);
  printWindow.document.close();

  // Ensure Tailwind is applied before printing
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


  const hasAnyFilter =
    Boolean(filters.startDate) ||
    Boolean(filters.endDate) ||
    Boolean(filters.bank) ||
    Boolean(filters.customer) ||
    Boolean(filters.search?.trim());

  const handleSearch = async () => {
    if (!hasAnyFilter) {
      toast.info("Enter at least one filter, then click Search.");
      return;
    }

    setIsSearching(true);
    try {
      const response = await axios.post(rootUrl(`/searchCash`), {
        uid: auth.user.id,
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
        bank: filters.bank || "",
        customer: filters.customer || "",
        search: (filters.search || "").trim(),
      });
      if (response.data.status === 200) {
        const rows = response.data.data || [];
        setCashbooks(rows);
        setFilteredCashbooks(rows);
        setMonthLockMap({});
        setHasSearched(true);
      } else {
        toast.error("Failed to load transactions");
      }
    } catch (error) {
      console.error("Error searching transactions:", error);
      toast.error("Error searching transactions");
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearFilters = () => {
    setFilters({
      startDate: "",
      endDate: "",
      bank: "",
      customer: "",
      search: "",
    });
    setCashbooks([]);
    setFilteredCashbooks([]);
    setMonthLockMap({});
    setHasSearched(false);
  };

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };

  

  const calculateBalance = () => {
    let balance = 0;


    return filteredCashbooks.map((row) => {
      if (parseInt(row.status) === 3) { // Only update balance if status is 3
        balance += row.type === 'income' ? parseFloat(row.amount) : -parseFloat(row.amount);
      }
      return { ...row, balance };
    });
  };

  const display = (obj) => {
    openSlidingDiv();
    if (obj.type === 'income') {
      setTitle("Receipt");
      setOutput(<Receipt data={cashbooks.filter(a=>a.voucher == obj.voucher)} ref={componentRef} />);
    } else {
      setTitle("Payment Voucher");
      setOutput(<PaymentVoucher data={obj} ref={componentRef} />);
    }
  };


  const handleDelete = async () => {
    if (!selectedObj) return;

    try {
      await axios.post(rootUrl(`/delCash`), {
        id: selectedObj.id,
        type: selectedObj.type,
        comment: comment, 
        voucher:selectedObj.voucher, 
        amount:selectedObj.amount,
        uid:auth.user.id
      });

      toast.success("Successful")
      setFilteredCashbooks((prev) =>
        prev.filter((item) => item.id !== selectedObj.id)
      );
      setIsOpen(false);
      setComment("");
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };
  
  const columns = [
    {
      name: 'Sn',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '50px',
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.date.substring(0, 10)),
      sortable: true,
    },
    {
      name: 'Chart of Account',
      selector: (row) =>
        allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
      sortable: true,
    },
    {
      name: 'Bank',
      selector: (row) =>
        allData?.bank?.find((a) => a.id == row.bank)?.name || '',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || '',
      sortable: true,
    },
    {
      name: 'Voucher #',
      selector: (row) => row.voucher || '',
      sortable: true,
    },{
      name: 'Cheque #',
      selector: (row) => row.cheque || '',
      sortable: true,
    },
    {
      name: 'Payee',
      selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
        
      ,
      sortable: true,
    },
    {
      name: 'Project',
      selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
      ,
      sortable: true,
    },
    {
      name: 'Debit',
      selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Credit',
      selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    // {
    //   name: 'Cashbook',
    //   selector: (row) => allData?.bank?.find((a) => a.id === row.bank)?.name || '',
    //   sortable: true,
    // },
 
    {
      name: 'Balance',
      selector: (row) => formatToZMW(row.balance || 0),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        (() => {
          const locked = isRowMonthLocked(row);
          return (
      
        <>
        <button
          className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
          onClick={() => display(row)}
        >
          <FaEye/>
        </button>
        <button
        className={`${locked ? "bg-gray-400 cursor-not-allowed" : "bg-red-900 hover:bg-blue-950"} text-white px-3 py-1 m-1 rounded`}
        onClick={() => openModal(row)}
        disabled={locked}
        title={locked ? "Month is locked" : "Delete"}
       
      >
        <FaTrash/>
      </button>
      <button
        className={`${locked ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"} text-white px-3 py-1 rounded`}
        onClick={() => handleEdit(row)}
        disabled={locked}
        title={locked ? "Month is locked" : "Edit"}
       
                    >
        <FaEdit />
      </button>
      </>
      );
        })()
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    if (!cashbooks.length) return;

    const checkMissingLocks = async () => {
      const uniqueEntries = new Map();

      cashbooks.forEach((row) => {
        const key = getMonthLockKey(row?.date, row?.bank);
        if (!key || monthLockMap[key] !== undefined) return;
        uniqueEntries.set(key, row);
      });

      if (uniqueEntries.size === 0) return;

      const entries = Array.from(uniqueEntries.values());
      const results = await Promise.all(
        entries.map(async (row) => {
          const key = getMonthLockKey(row?.date, row?.bank);
          const isLocked = await checkMonthLockForRow(row);
          return { key, isLocked };
        })
      );

      setMonthLockMap((prev) => {
        const updated = { ...prev };
        results.forEach(({ key, isLocked }) => {
          if (key) updated[key] = isLocked;
        });
        return updated;
      });
    };

    checkMissingLocks();
  }, [cashbooks]);

  const finalBalance = filteredCashbooks.reduce((total, row) => {
    if (parseInt(row.status) === 3) { // only status 3
      const amount = parseFloat(row.amount) || 0; 
      return row.type === 'income' ? total + amount : total - amount;
    }
    return total; // if not status 3, don't change total
  }, 0);
  

       const customerOptions = (allData?.suppliers || []).map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));
       

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <FaCashRegister className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Transaction List</h1>
              <p className="text-blue-100 text-sm mt-1">
                View, filter, and manage all cashbook transactions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">

        {/* Filters */}
        <div className="mt-2 mb-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <input
          type="date"
          className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={filters.startDate}
          onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
        />
        <input
          type="date"
          className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={filters.endDate}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <select
          className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={filters.bank}
          onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
        >
          <option value="">All Cashbooks</option>
          {allData?.bank?.map((bank) => (
            <option key={bank.id} value={bank.id}>
              {bank.name}
            </option>
          ))}
        </select>

        <Select
          options={customerOptions}
          placeholder="Payee"
          isClearable
          value={customerOptions.find(option => option.value === filters.customer)}
          onChange={(selectedOption) =>
            setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
          }
          className="text-sm"
        />
        <input
          type="text"
          placeholder="Search by description, voucher or cheque..."
          className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
        <div className="flex items-center text-xs md:text-sm text-gray-600">
          <span className="font-medium mr-1">Showing:</span>
          {filteredCashbooks.length} record{filteredCashbooks.length === 1 ? "" : "s"}
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={handleSearch}
            disabled={isSearching}
            className="inline-flex items-center justify-center rounded-lg bg-blue-950 px-4 py-2 text-sm font-medium text-white hover:bg-blue-900 disabled:opacity-60"
          >
            {isSearching ? "Searching..." : "Search"}
          </button>
          <button
            type="button"
            onClick={handleClearFilters}
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Clear
          </button>
        </div>
      </div>

        <p className="text-xs text-gray-500 mb-2">
          A list of all cash transactions with running balance. Rows in red are reversed/voided.
        </p>

        {filteredCashbooks.length > 0 && allData.budget !== undefined ? (
        <>
          <div className="rounded-xl border border-gray-100 bg-white overflow-hidden">
            <div className="w-full mx-auto overflow-x-auto">
              <DataTable
                title=""
                columns={columns}
                data={calculateBalance()}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={customStyles}
                conditionalRowStyles={[
                  {
                    when: row => parseInt(row.status) === 4,
                    style: {
                      backgroundColor: 'rgba(248, 113, 113, 0.15)',
                      color: '#b91c1c',
                    },
                  },
                ]}
              />
            </div>
          </div>
          <div className="text-right font-semibold mt-3 text-sm md:text-base text-gray-800">
            Final Balance:{" "}
            <span className="font-bold text-blue-950">
              {formatToZMW(finalBalance)}
            </span>
          </div>
        </>
      ) : (
        <div className="mt-6 flex flex-col justify-center items-center py-10">
          <FaFolderOpen className="text-gray-400 text-6xl mb-2" />
          <p className="text-sm text-gray-600">
            {hasSearched
              ? "No cash records found for the selected filters."
              : "Select one or more filters, then click Search to load transactions."}
          </p>
        </div>
      )}

        {/* Delete Confirmation Modal */}
        {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white p-5 rounded-2xl shadow-xl w-full max-w-md">
            <h2 className="text-lg font-semibold text-gray-800">
              Enter a Comment
            </h2>
            <p className="mt-1 text-xs text-gray-500">
              Please provide a reason for reversing this cashbook entry.
            </p>
            <textarea
              className="w-full p-2 border border-gray-300 rounded-lg mt-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="3"
              placeholder="Write a reason for deletion..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            ></textarea>
            <div className="mt-4 flex justify-end gap-2">
              <button
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

        {/* Sliding receipt/voucher panel */}
        {showSlidingDiv && (
        <div className="fixed inset-0 z-40 flex justify-end">
          <div
            className="flex-1 bg-black/40"
            onClick={closeSlidingDiv}
          />
          <div
            id="slidingDiv"
            className="bg-white h-full w-full sm:w-4/5 lg:w-2/3 xl:w-1/2 shadow-2xl relative flex flex-col"
          >
            <div className="flex items-center justify-between p-3 border-b border-gray-200">
              <h3 className="font-semibold text-sm md:text-lg text-gray-800">
                {title}
              </h3>
              <button
                onClick={closeSlidingDiv}
                className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-red-50 text-red-600 hover:bg-red-100"
              >
                <FaTimes size={14} />
              </button>
            </div>

            <div className="flex gap-3 p-3 border-b border-gray-100">
              <button
                onClick={handleExportToPDF}
                className="inline-flex items-center bg-blue-950 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium hover:bg-blue-900"
              >
                <FaFilePdf className="mr-1" />
                PDF
              </button>

              <button
                onClick={handlePrint}
                className="inline-flex items-center bg-blue-950 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium hover:bg-blue-900"
              >
                <FaPrint className="mr-1" />
                Print
              </button>
            </div>

            <div
              id="form"
              ref={componentRef}
              className="flex-1 overflow-auto p-3 md:p-4"
            >
              {output}
            </div>
          </div>
        </div>
      )}

        {/* Edit Modal */}
        {isEditModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center overflow-y-auto z-50">
          <div className="bg-white p-4 md:p-5 rounded-2xl shadow-xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
            <h2 className="text-lg md:text-xl font-semibold mb-3 text-gray-800">
              Edit Entry
            </h2>
            <label className="block mb-1 text-xs font-medium text-gray-600">
              Date
            </label>
            <input
              type="date"
              name="date"
              value={editData.date}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg mb-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Cheque #
            </label>
            <input
              type="text"
              name="cheque"
              value={editData.cheque}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg mb-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Description
            </label>
            <textarea
              name="description"
              value={editData.description}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg mb-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={3}
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Budget
            </label>
            <Select
              options={allData.budget.map(getOptionDetails)}
              placeholder="Select budget"
              onChange={(selected) => handleSelectChange(selected, 'coa_id')}
              value={editData.coa_id}
              className="mb-3 text-sm"
              isClearable
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Project
            </label>
            <Select
              options={allData.projects.map((res)=>({value:res.id, label:res.name + ' - ' + res.description}))}
              placeholder="Select project"
              onChange={(selected) => handleSelectChange(selected, 'project')}
              value={editData.project}
              className="mb-3 text-sm"
              isClearable
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Source of Fund
            </label>
            <Select
              options={allData.sof?.map((res)=>({value:res.id, label:res.name}))}
              placeholder="Select source of fund"
              onChange={(selected) => handleSelectChange(selected, 'sof')}
              value={editData.sof}
              className="mb-3 text-sm"
              isClearable
            />

            <label className="block mb-1 text-xs font-medium text-gray-600">
              Bank
            </label>
            <Select
              options={allData.bank.map((res)=>({value:res.id, label:res.name}))}
              placeholder="Select bank"
              onChange={(selected) => handleSelectChange(selected, 'bank')}
              value={editData.bank}
              className="mb-4 text-sm"
              isClearable
            />

            <div className="flex justify-end space-x-2">
              <button
                className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-300"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700"
                onClick={handleSubmit}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
  );
};

export default CashbookPage;
